import api from 'api';

export const loadTable = api('POST /api/hourly-tracker/table');

export const loadColumns = api('GET /api/hourly-tracker/table/columns');

export const loadDimensions = api('POST /api/hourly-tracker/table/dimensions');
export const loadDrillTo = api('POST /api/hourly-tracker/table/drillTo');

export const exportHourlyTracker = api('POST /api/hourly-tracker/table/csv', {
  responseType: 'blob',
});
